import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const laboratoryContractApi = {
    getLaboratoryContractByLaboratoryId: (laboratoryId: number): Observable<Dtos.GetLaboratoryContractByLaboratoryIdResponse> => {
        //Create the request.
        let request: Dtos.GetLaboratoryContractByLaboratoryId = new Dtos.GetLaboratoryContractByLaboratoryId();
        request.laboratoryId = laboratoryId;

        //Send request.
        const response: Promise<Dtos.GetLaboratoryContractByLaboratoryIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getLaboratoryContractById: (id: number): Observable<Dtos.GetLaboratoryContractByIdResponse> => {
        //Create the request.
        let request: Dtos.GetLaboratoryContractById = new Dtos.GetLaboratoryContractById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetLaboratoryContractByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setLaboratoryContract: (laboratoryContract: Dtos.LaboratoryContract): Observable<Dtos.SetLaboratoryContractResponse> => {

        let request: Dtos.SetLaboratoryContract = new Dtos.SetLaboratoryContract();

        request.laboratoryContract = laboratoryContract;

        // send request
        const response: Promise<Dtos.SetLaboratoryContractResponse> = client.post(request);

        return Observable.from(response);
    },
    createLaboratoryContract: (laboratoryId: number): Observable<Dtos.CreateLaboratoryContractResponse> => {
        //Create the request.
        let request: Dtos.CreateLaboratoryContract = new Dtos.CreateLaboratoryContract();

        request.laboratoryId = laboratoryId;

        //Send request.
        const response: Promise<Dtos.CreateLaboratoryContractResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateLaboratoryContract: (laboratoryContract: Dtos.LaboratoryContract): Observable<Dtos.ValidateLaboratoryContractResponse> => {

        let request: Dtos.ValidateLaboratoryContract = new Dtos.ValidateLaboratoryContract();

        request.laboratoryContract = laboratoryContract;

        // send request
        const response: Promise<Dtos.ValidateLaboratoryContractResponse> = client.post(request);

        return Observable.from(response);
    },
}